module.exports = __webpack_public_path__ + "img/favicon-vimo.94d69ab4.svg";